{
  "version": 1,
  "asset_id": "e7a5c243-87a8-4448-a9b6-5061d878bc12",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/e7a5c243-87a8-4448-a9b6-5061d878bc12/hiatal-type-2-es-v3-800.jpg",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/e7a5c243-87a8-4448-a9b6-5061d878bc12/hiatal-type-2-es-v3-800.jpg",
  "original_filename": "hiatal-type-2-es-v3-800.jpg",
  "size": 145460,
  "content_type": "image/jpeg",
  "created_at": "2026-10-28T19:42:26Z"
}
